export default defineNuxtPlugin(async (nuxtApp) => {
    const { default: vSelect } = await import("vue-select");

    nuxtApp.vueApp.component("v-select", vSelect);

    return {
        provide: {
            vSelect
        },
    }
})
